import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

// Q: What is the `{ noSsr: true }` option for?
//
// A: By default, useMediaQuery tries to support SSR (server-side rendering).
//  To do this, it first needs to render without knowing the viewport size,
//  and then it renders again with the actual correct value.
//
// This messes up some components, like <AxlePageWithMap/>, which tries to
//  pass in an initial map size prop to the splitter layout, but the first
//  value ends up being the wrong one.
//
// To avoid this, we set the `{ noSsr: true }` option to true.
//
// See: https://github.com/mui/material-ui/issues/21142#issuecomment-633144987

// Whether the screen size is 'sm', 'md', 'lg', or 'xl' or smaller.
export const useIsDown = (breakpoint: Breakpoint): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true });
};

// Whether the screen size is at least 'sm', 'md', 'lg', or 'xl'.
export const useIsUp = (breakpoint: Breakpoint): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up(breakpoint), { noSsr: true });
};

// Whether the screen size is 'sm' or smaller.
export const useIsMobile = (): boolean => useIsDown('sm');

export const isPhoneWidth = (width: number | undefined) => width !== undefined && width <= 440;
